module.exports = __webpack_public_path__ + "static/media/GraphQL.bf168ad8.jpg";